import * as React from 'react';
const SvgComponent = ({
    width = 42,
    height = 43,
    color = '#F3F3F3',
    ...props
}: {
    width?: number;
    height?: number;
    color?: string;
    [x: string]: any;
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 42 43"
            fill="none"
            {...props}
        >
            <path
                fill="#fff"
                d="M6.125 19.46 7 15.96l3.5-.874L7 14.21l-.875-3.5-.875 3.5-3.5.875 3.5.875.875 3.5Z"
            />
            <path
                fill={color}
                d="M6.125 19.46 7 15.96l3.5-.874L7 14.21l-.875-3.5-.875 3.5-3.5.875 3.5.875.875 3.5Z"
            />
            <path
                fill="#fff"
                d="m26.25 15.96 1.645-3.622 3.605-1.627-3.605-1.628-1.645-3.622-1.61 3.622L21 10.711l3.64 1.627 1.61 3.623Z"
            />
            <path
                fill={color}
                d="m26.25 15.96 1.645-3.622 3.605-1.627-3.605-1.628-1.645-3.622-1.61 3.622L21 10.711l3.64 1.627 1.61 3.623Z"
            />
            <path
                fill="#fff"
                d="M36.75 14.21c-2.538 0-3.955 2.52-3.377 4.393l-6.213 6.23c-.525-.157-1.295-.157-1.82 0l-4.462-4.462c.595-1.873-.823-4.41-3.378-4.41-2.537 0-3.973 2.52-3.377 4.41l-7.98 7.962c-1.873-.577-4.393.84-4.393 3.378a3.51 3.51 0 0 0 3.5 3.5c2.537 0 3.955-2.52 3.377-4.393l7.963-7.98c.525.158 1.295.158 1.82 0l4.462 4.463c-.595 1.872.823 4.41 3.378 4.41 2.538 0 3.973-2.52 3.378-4.41l6.23-6.213c1.872.578 4.392-.84 4.392-3.377a3.51 3.51 0 0 0-3.5-3.5Z"
            />
            <path
                fill={color}
                d="M36.75 14.21c-2.538 0-3.955 2.52-3.377 4.393l-6.213 6.23c-.525-.157-1.295-.157-1.82 0l-4.462-4.462c.595-1.873-.823-4.41-3.378-4.41-2.537 0-3.973 2.52-3.377 4.41l-7.98 7.962c-1.873-.577-4.393.84-4.393 3.378a3.51 3.51 0 0 0 3.5 3.5c2.537 0 3.955-2.52 3.377-4.393l7.963-7.98c.525.158 1.295.158 1.82 0l4.462 4.463c-.595 1.872.823 4.41 3.378 4.41 2.538 0 3.973-2.52 3.378-4.41l6.23-6.213c1.872.578 4.392-.84 4.392-3.377a3.51 3.51 0 0 0-3.5-3.5Z"
            />
        </svg>
    );
};
export default SvgComponent;
